import React, { Component } from "react";
import { connect, Provider } from "react-redux";
import { authStore } from "../../store/store";
import { Route, Switch } from "react-router-dom";
import Footer from "../../../home/components/Footer/footer.component";
import UsersList from "./UsersList/UsersListPage.component";
import "./UsersManagementPage.component.scss";
import { isAdmin } from "../../../../utils/Authorization/authorization";

class UsersManagementPage extends Component {
    render() {
        return (
            <Provider store={authStore}>
                <div id="UsersManagementPage">
                    <Switch>
                        {isAdmin() && (
                            <Route
                                exact
                                path={"/users/"}
                                component={UsersList}
                            />
                        )}
                    </Switch>
                    <Footer />
                </div>
            </Provider>
        );
    }
}

export default UsersManagementPage;
